import { render, staticRenderFns } from "./SkipIntro.vue?vue&type=template&id=6f5be036&scoped=true&"
import script from "./SkipIntro.vue?vue&type=script&lang=js&"
export * from "./SkipIntro.vue?vue&type=script&lang=js&"
import style0 from "./SkipIntro.vue?vue&type=style&index=0&id=6f5be036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5be036",
  null
  
)

export default component.exports